import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useFlagsForUniversalAttributes = () => {
  const enableFlavorFlow = useFlag(LaunchDarklyFlag.ENABLE_FLAVOR_FLOW);

  return {
    enableFlavorFlow,
  };
};
